import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const features = [
  {
    icon: 'bi bi-file-earmark-text',
    title: 'GST-Ready Invoicing',
    desc: 'Create professional, GST-compliant invoices in just a few clicks.'
  },
  {
    icon: 'bi bi-bar-chart-line',
    title: 'Complete Business Management',
    desc: ' From billing and inventory to e-Way Bills and reports -manage everything in one place.'
  },
  {
    icon: 'bi bi-translate',
    title: 'Regional Language Support',
    desc: ' Available in English, Hindi, and other local languages for your convenience.'
  },
  {
    icon: 'bi bi-headset',
    title: 'Dedicated Customer Support',
    desc: 'Get expert help anytime -we’re here for you 24x7.'
  }
];

const Features = () => (
  <section className="section features__v2" id="features">
    <Container fluid className="px-0">
      <Row className="mx-0">
        <Col className="px-0">
          <Card className="d-lg-flex py-3 px-0 px-md-3 rounded-4 content">

            <Row>
              <Col lg={5} className="mb-5 mb-lg-0">
                <div className="h-100 flex-column justify-content-between d-flex">
                  <div>
                    <h2 className="mb-4">Why Choose HamaraBillBook?</h2>
					{/*<h3 className="mb-4">Smart Billing. Simple Interface. Trusted Across India.</h3>*/}

                    <p className="mb-5">Smart Billing. Simple Interface. Trusted Across India. Choosing the right billing software can transform your 
						business. At HamaraBillBook, we understand the unique challenges of 
						Indian small businesses -and that’s why we’ve created a solution that’s 
						fast, reliable, and easy to use. Whether you run a shop, wholesale
						 business, or provide services, HamaraBillBook is designed to help 
						 you manage billing, inventory, and compliance -all from one powerful platform.</p>
                  </div>
                  {/*<div className="align-self-start">
                    <a className="btn btn-play d-inline-flex align-items-center gap-2" href="https://www.youtube.com/watch?v=DQx96G4yHd8" target="_blank" rel="noopener noreferrer">
                      <i className="bi bi-play-fill"></i> Watch the Video
                    </a>
                  </div>*/}
                </div>
              </Col>
              <Col lg={7}>
                <Row className="justify-content-end">
                  <Col lg={11} className="px-0 px-md-3">
                    <Row>
                      {features.map((f, idx) => (
                        <Col sm={6} key={idx} className="mb-4">
                          <div className="icon text-center mb-4"><i className={f.icon + ' fs-4'}></i></div>
                          <h3 className="fs-6 fw-bold mb-3">{f.title}</h3>
                          <p>{f.desc}</p>
                        </Col>
                      ))}
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Container>
  </section>
);

export default Features; 